// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d27ae741","453":"a7a35927","455":"abff21a4"}[chunkId] + ".chunk.js";
};